import React, { useEffect, useRef } from "react";
import { updateVideoStream } from "lib/liveStreamHelpers";
import { ProduceStream } from "types";
import BaseAvatar from "components/BaseAvatar";
import BaseIcon from "components/BaseIcon";
import "./style.scss";

interface Props {
  item: ProduceStream;
  className?: string;
  forceMute?: boolean;
  onClick: () => void;
  setPlayer?: React.Dispatch<React.SetStateAction<HTMLVideoElement | null>>;
  hide?: boolean;
  contain?: boolean;
  isSpeaking?: boolean;
}

export default function ProduceStreamItem({
  item,
  className,
  forceMute,
  hide,
  contain,
  isSpeaking,
  onClick,
  setPlayer,
}: Props) {
  const player = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    return updateVideoStream(player.current, item.stream);
  }, [item.stream, item.hasVideo, item.hasAudio, player]);

  useEffect(() => {
    setPlayer && setPlayer(player.current);
  }, [player, setPlayer]);

  const cls = ["produce-stream-item d-center pointer"];
  if (!item.hasVideo) cls.push("__disabled-video");
  if (hide) cls.push("hidden");
  if (className) cls.push(className);
  if (contain) cls.push("__contain");
  if (isSpeaking) cls.push("__speaking");

  return (
    <div className={cls.join(" ")} onClick={onClick}>
      <video className="produce-stream-item__video" ref={player} muted={forceMute} playsInline autoPlay />
      {!item.hasVideo && <BaseAvatar size={50} user={item.user.user} />}
      {item.user.screenName && (
        <div className="produce-stream-item__screen-name pa-1 truncate-ellipsis">{item.user.screenName}</div>
      )}
      {!item.hasAudio && (
        <div className="produce-stream-item__muted">
          <BaseIcon className="produce-stream-item__muted-icon" size={18}>
            mic_off
          </BaseIcon>
        </div>
      )}
    </div>
  );
}
